var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { Table, Pagination, TableData, TableDataTypes } from 'src/app/shared/types';
import { CaptainRedeemService } from 'src/app/captain-redeem-service';
import * as moment from 'moment';
var HostWalletTransactionsComponent = /** @class */ (function () {
    function HostWalletTransactionsComponent(redeemService) {
        this.redeemService = redeemService;
        this.toggleHeaders = new EventEmitter();
        this.transactions = [];
        this.perPage = 10;
        this.next = "";
        this.prev = "";
        this.firstElement = "";
        this.lastElement = "";
        this.dataLoaded = false;
    }
    HostWalletTransactionsComponent.prototype.ngOnChanges = function (changes) {
        if (changes.profileId && changes.profileId.currentValue) {
            this.profileId = changes.profileId.currentValue;
            if (this.profileId) {
                this.initializeTable();
                this.fillDataToTable();
            }
        }
    };
    HostWalletTransactionsComponent.prototype.ngOnInit = function () {
        if (this.profileId) {
            this.initializeTable();
            this.fillDataToTable();
        }
    };
    HostWalletTransactionsComponent.prototype.changeInHeader = function (header) {
        this.toggleHeaders.emit(header);
    };
    HostWalletTransactionsComponent.prototype.initializeTable = function (pageNumber) {
        var _this = this;
        if (pageNumber === void 0) { pageNumber = 0; }
        this.transactionsTable = new Table({
            toggleableHeaders: this.hostDetailsToggleableHeaders,
            selectedHeader: this.hostDetailsToggleableHeaders.indexOf('Wallet Transactions'),
            headers: {
                dateTime: 'Date & Time',
                type: 'Type',
                amount: 'Amount',
                transactionType: 'Transaction Type',
                transactionId: 'Transaction ID',
                status: 'Status'
            },
            pagination: new Pagination(pageNumber, this.perPage),
            defaultError: 'No transactions found',
            data: [],
            config: {
                refresh: true,
            },
            onRefresh: function () {
                _this.transactionsTable = null;
                _this.next = "";
                _this.prev = "";
                _this.ngOnInit();
            }
        });
    };
    HostWalletTransactionsComponent.prototype.onPaginationChange = function (event) {
        if (event.pageNo < event.previousPageIndex) {
            this.next = "";
            this.prev = this.firstElement;
        }
        else if (event.pageNo > event.previousPageIndex) {
            this.prev = "";
            this.next = this.lastElement;
        }
        this.perPage = event.perPage;
        this.fillDataToTable();
    };
    HostWalletTransactionsComponent.prototype.fillDataToTable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requestBody, response, transactionArray, createTableData_1, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.profileId) return [3 /*break*/, 5];
                        this.dataLoaded = false;
                        requestBody = {
                            "transactionType": ["orders", "redeem", "referrals"]
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.redeemService.getWalletCaptainPassbookFromWallet(this.profileId, requestBody, this.perPage, this.next, this.prev)];
                    case 2:
                        response = _a.sent();
                        this.dataLoaded = true;
                        transactionArray = response && response.data ? response.data : [];
                        if (transactionArray.length > 0) {
                            this.firstElement = transactionArray[0].id;
                            this.lastElement = transactionArray[transactionArray.length - 1].id;
                        }
                        createTableData_1 = function (value, className) {
                            return new TableData({
                                data: value,
                                type: TableDataTypes.DATA,
                                className: className ? className + ' cursor-pointer' : 'cursor-pointer whiteSpacePre'
                            });
                        };
                        this.transactions = transactionArray.map(function (transaction) {
                            var formattedDate = _this.formatDateToIST(transaction.time);
                            var formattedAmount = _this.formatAmount(transaction.amount, transaction.type);
                            var transactionTypeDisplay = _this.mapTransactionType(transaction.transactionType);
                            var statusDisplay = _this.mapStatus(transaction.status);
                            var typeDisplay = transaction.type ? transaction.type.charAt(0).toUpperCase() + transaction.type.slice(1) : 'N/A';
                            var transactionId = transaction.id || 'N/A';
                            return {
                                dateTime: createTableData_1(formattedDate),
                                type: createTableData_1(typeDisplay),
                                amount: createTableData_1(formattedAmount, transaction.type === 'debit' ? 'color-red' : 'color-green'),
                                transactionType: createTableData_1(transactionTypeDisplay),
                                transactionId: createTableData_1(transactionId),
                                status: createTableData_1(statusDisplay)
                            };
                        });
                        this.transactionsTable.data = this.transactions;
                        if (transactionArray.length === this.perPage) {
                            this.transactionsTable.pagination.count = (this.transactionsTable.pagination.pageNo + 1) * this.perPage + 1;
                        }
                        else {
                            this.transactionsTable.pagination.count = (this.transactionsTable.pagination.pageNo * this.perPage) + transactionArray.length;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.dataLoaded = true;
                        this.transactionsTable.data = [];
                        this.transactionsTable.pagination.count = 0;
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.dataLoaded = true;
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    HostWalletTransactionsComponent.prototype.mapTransactionType = function (transactionType) {
        var typeMap = {
            'orders': 'Orders',
            'redeem': 'Redeem',
            'referrals': 'Referrals'
        };
        return typeMap[transactionType] || (transactionType ? transactionType.charAt(0).toUpperCase() + transactionType.slice(1) : 'N/A');
    };
    HostWalletTransactionsComponent.prototype.mapStatus = function (status) {
        var statusMap = {
            'success': 'Completed',
            'pending': 'Pending',
            'failed': 'Failed',
            'cancelled': 'Cancelled'
        };
        return statusMap[status] || (status ? status.charAt(0).toUpperCase() + status.slice(1) : 'N/A');
    };
    HostWalletTransactionsComponent.prototype.formatDateToIST = function (time) {
        if (!time) {
            return 'N/A';
        }
        // Convert epoch timestamp (milliseconds) to IST
        var istDate = moment(time).utcOffset('+05:30');
        var dateInfo = istDate.format('DD MMM YYYY');
        var timeInfo = istDate.format('HH:mm:ss');
        return dateInfo + "\n" + timeInfo;
    };
    HostWalletTransactionsComponent.prototype.formatAmount = function (amount, type) {
        if (amount === null || amount === undefined) {
            return 'N/A';
        }
        var formattedAmount = Math.abs(amount).toFixed(2);
        var sign = type === 'debit' ? '-' : '';
        return sign + "\u20B9" + formattedAmount;
    };
    return HostWalletTransactionsComponent;
}());
export { HostWalletTransactionsComponent };
